import React from 'react';
import EvalentXLogo from '../landing/Logo';

const PALETTES = {
  accent: { bars: '#111111', left: '#365CFF', node: '#D7FF38' },
  mono: { bars: '#111111', left: '#111111', node: '#111111' },
  inverse: { bars: '#F5F3EB', left: '#365CFF', node: '#D7FF38' },
};

// Two pathways converging into one node: the CONVERGE mark.
export const ConvergeMark = ({ size = 40, variant = 'accent', animated = false, className = '' }) => {
  const c = PALETTES[variant];
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" role="img" aria-label="CONVERGE mark" className={className}>
      <path d="M4 6 L20 24 L4 42" fill="none" stroke={c.left} strokeWidth="6" strokeLinejoin="miter" />
      <path d="M44 6 L28 24 L44 42" fill="none" stroke={c.bars} strokeWidth="6" strokeLinejoin="miter" />
      <rect x="18" y="18" width="12" height="12" transform="rotate(45 24 24)" fill={c.node}
        stroke={variant === 'mono' ? 'none' : c.bars} strokeWidth="2.5" className={animated ? 'cv-node' : ''} />
    </svg>
  );
};

export const ConvergeLogo = ({ variant = 'accent', compact = false, endorse = true }) => {
  const ink = variant === 'inverse' ? '#F5F3EB' : '#111111';
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="converge-logo">
      <ConvergeMark size={compact ? 34 : 38} variant={variant} />
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="cv-display font-extrabold text-[22px] tracking-tight" style={{ color: ink }}>CONVERGE</span>
          {endorse && <span className="text-[10px] font-bold uppercase tracking-[0.2em] mt-1" style={{ color: ink, opacity: 0.7 }}>by EvalentX</span>}
        </span>
      )}
    </span>
  );
};

export { EvalentXLogo };

export const EvalentXEndorse = ({ className = '' }) => (
  <span className={`inline-flex items-center gap-2 bg-white border-2 border-[#111] px-2.5 py-1.5 ${className}`} data-testid="evalentx-endorse">
    <span className="text-[10px] font-bold uppercase tracking-[0.2em]">by</span>
    <EvalentXLogo size="sm" noLink />
  </span>
);
